import type {ReactElement} from 'react';
import React from 'react';
import type {ColorPaletteStylesOptionProps} from './color-palette-styles-option.types';
import {ContextualMenuPaletteOption} from '@Components/contextual-menu/components/contextual-menu-palette-option/contextual-menu-palette-option';
import {Tag, TagType} from '@Components/tag';
import {GA4EventName, GA4EventParamName, GA4EventSources, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {sortColorsByPerceptualLightness} from '@Utils/cielab-color.util';

export function ColorPaletteStylesOption({showNewTag = false, ...props}: ColorPaletteStylesOptionProps): ReactElement | null {
  const getNewTag = (): ReactElement | undefined => {
    return showNewTag ? (
      <Tag className={'radius-round spacing-p-l-2 spacing-p-r-2 spacing-p-t-1 spacing-p-b-1'} text={window.i18next.t('pmwjs_new')} type={TagType.SECONDARY} />
    ) : undefined;
  };

  const getColorPalettesStyleOptions = (): ReactElement | null => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return null;
    }

    let palette = currentPage.appliedPalette;
    if (!palette) {
      palette = {
        colors: sortColorsByPerceptualLightness(
          currentPage.getColorsOnPage().map((color) => {
            return `#${color}`;
          })
        ).slice(0, 5),
      };
    }

    const onClick = (): void => {
      trackPosterBuilderGA4Events(GA4EventName.EDITOR_STYLES_VISITED, {[GA4EventParamName.SOURCE]: GA4EventSources.CONTEXTUAL_MENU});
      props.onClick();
    };

    return <ContextualMenuPaletteOption onClick={onClick} label={window.i18next.t('pmwjs_styles')} id={'page-color-palette-option'} tag={getNewTag()} appliedPalette={palette} />;
  };

  return getColorPalettesStyleOptions();
}
